// @flow
import React, { PureComponent, type ComponentType } from "react";
import { getDisplayName } from "data/constants";
import { DocListColumnType, LastChangeState } from "data/types";
import Operators from "./Operators";
import { type DocListFilterOperatorsEnum } from "data/types";
import styles from "./DocListFilterModal.module.css";

type Props = {
    /** currently selected filterOperator */
    filterOperator: DocListFilterOperatorsEnum,
    /** callback when value has been changed
     * @param {string} name field's name
     * @param {any} value new field's value
     */
    onChange: (name: string, value: any) => void,
    /** current value */
    value: any,
    /** current name */
    name: string,
    index: number,
    col: any,
    filter: any,
    index: number,
};

type State = {
    /** currently selected filterOperator */
    op: DocListFilterOperatorsEnum,
    /** current value */
    value: any,
};

/** wraps *EditorControls to add Filter Operators and handling */
const toFilterEditor = (WrappedComponent: ComponentType<any>) =>
    class PP extends PureComponent<Props, State> {
        upstreamOnChange: (value: any, index: number) => void;

        static displayName = `toFilterEditor(${getDisplayName(
            WrappedComponent
        )})`;

        constructor(props: Props) {
            super(props);
            this.state = {
                op: props.filterOperator,
                value: props.value,
            };
            this.upstreamOnChange = this.props.onChange;
        }

        _onChange = () => {
            this.upstreamOnChange(this.state.value, this.props.index);
        };

        _onChangeValue = (
            name: Array<LastChangeState> | string,
            value: any
        ) => {
            // special handling for lookup fields
            if (Array.isArray(name)) {
                this.setState({ value: name[0]?.value }, this._onChange);
                return;
            }
            this.setState({ value }, this._onChange);
        };

        _onChangeOperator = (op: SearchOperatorEnum) =>
            this.setState({ op, value: null });

        _getType = (col: any) =>
            col.extra
                ? col.extra.format?.replace("_", "").concat("Value")
                : col.type;

        render = () => (
            <WrappedComponent
                {...this.props}
                onChange={this._onChangeValue}
                filterEditorProps={{
                    filter: this.props.filter,
                    onOperatorChange: this._onChangeOperator,
                }}
                afterHeaderComponentClass={() =>
                    this.props.col.type !== DocListColumnType.BooleanValue && (
                        <Operators
                            id={`${this.props.col?.name}_operator`}
                            index={this.props.index}
                            value={this.props.filter.operator}
                            type={this._getType(this.props.col)}
                            onChange={this.props.onOperatorChange}
                            styleClass={styles.operator}
                        />
                    )
                }
            />
        );
    };

export default toFilterEditor;
